import React, { FC, useEffect, useState } from 'react';
import { Menu } from 'types/menu';
import { Company } from 'types/company';
import { Meta } from 'types/meta';
import { Entity } from 'types/entity';
import { initialMenu } from 'services/initialStates';
import { FileMenu } from 'client/components/MenuComponents/FileMenu';
import { LinkMenu } from 'client/components/MenuComponents/LinkMenu';
import { useParams } from 'react-router-dom';

export const MenuPage: FC<{
  entity: Entity;
  company: Company;
  meta: Meta;
}> = ({ entity, company, meta }) => {
  const { id } = useParams() as { id: string };
  const [menu, setMenu] = useState<Menu>(initialMenu);
  const [readyToRender, setReadyToRender] = useState<boolean>(false);

  useEffect(() => {
    const menu = entity.menu.find(m => m.id === id) as Menu;
    setMenu(menu);
    setReadyToRender(true);
  }, []);

  if (!readyToRender) return <div />;
  return menu.type === 'file' ? (
    <FileMenu menu={menu} company={company} meta={meta} />
  ) : (
    <LinkMenu menu={menu} company={company} meta={meta} />
  );
};
